var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "map-container" }, [
    _c("div", {
      style: { height: _vm.height + "px", width: _vm.width },
      attrs: { id: "mapContainer" },
    }),
    _vm.searchShow
      ? _c(
          "div",
          { staticClass: "search-poi" },
          [
            _c(
              "el-select",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  filterable: "",
                  remote: "",
                  "reserve-keyword": "",
                  placeholder: "请输入关键词",
                  "remote-method": _vm.remoteMethod,
                  loading: _vm.loading,
                  clearable: "",
                },
                on: { change: _vm.change },
                model: {
                  value: _vm.value,
                  callback: function ($$v) {
                    _vm.value = $$v
                  },
                  expression: "value",
                },
              },
              _vm._l(_vm.options, function (item) {
                return _c("el-option", {
                  key: item.uid,
                  attrs: { label: item.address, value: item.uid },
                })
              }),
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }